import { Table } from 'antd';
import PropTypes from 'prop-types';
import './styles.scss';

const { Column } = Table;
const ITEM_PER_PAGE = 10;

const MyTableV2 = ({
  className,
  data,
  columns,
  totalItem,
  onChange,
  onPaginationChange,
  pageSize,
  currentPage,
  showHeader = true,
  loading = false,
  scroll = {},
  onClickRow,
  cellKeysNotActiveOnClickRow = ['action'],
  rowKey,
  ...rest
}) => {
  return (
    <div className={`my-table-v2  ${className || ''}`}>
      <Table
        dataSource={data}
        rowClassName="my-table-header-v2"
        pagination={false}
        showHeader={showHeader}
        loading={loading}
        scroll={scroll}
        rowKey={rowKey ? rowKey : (row) => row.id}
        onChange={onChange}
        {...rest}
      >
        {columns.map((column) => (
          <Column
            {...column}
            className={column.className}
            title={column.title}
            key={column.key}
            dataIndex={column.key}
            render={column.render}
            align={column.align}
            onCell={
              cellKeysNotActiveOnClickRow.indexOf(column.key) < 0 && onClickRow
            }
          />
        ))}
      </Table>
      {totalItem !== 0 && (
        <MyPagination
          currentPage={currentPage}
          totalItem={totalItem}
          pageSize={pageSize}
          onChange={onChangePagination}
        />
      )}
    </div>
  );
};

export default MyTableV2;

MyTableV2.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  className: PropTypes.string,
  totalItem: PropTypes.number,
  currentPage: PropTypes.number,
  onChange: PropTypes.func,
  showHeader: PropTypes.bool,
  loading: PropTypes.bool,
  scroll: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
};

MyTableV2.defaultProps = {
  totalItem: 0,
  currentPage: 1,
  pageSize: ITEM_PER_PAGE,
  onChange: () => (page) => console.log(page),
};
